import angular from 'angular';

module.exports = angular.module('common.services.formatted-cursor-position', [])
.factory('formattedCursorPosition', function() {
  return function(oldCursorPosition, oldValue, newValue) {
    // Move the cursor as far right as possible such that it will have the same
    // number of digits to its left as before
    let beforeCursorText = oldValue.toString().substr(0, oldCursorPosition);
    let beforeCursorDigitCount = beforeCursorText.replace(/\D/g, '').length;
    let cursorPositionRegex = new RegExp('^\\D*(\\d\\D*){' + beforeCursorDigitCount + '}');
    let match = newValue.match(cursorPositionRegex);

    return match ? match[0].length : newValue.length;
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/services/formatted-cursor-position.js
 **/